import { createFileRoute } from "@tanstack/react-router";
import type { JSX } from "react";

import { InventoryPage, paramsToFilter, type InventoryFilterState } from "@/features/inventory";

function InventoryRoute(): JSX.Element {
  const navigate = Route.useNavigate();
  const search = Route.useSearch();
  return (
    <InventoryPage
      urlFilter={search}
      onUrlFilterChange={(next) => void navigate({ search: next })}
    />
  );
}

export const Route = createFileRoute("/_authenticated/inventory")({
  validateSearch: (raw: Record<string, unknown>): InventoryFilterState =>
    paramsToFilter(raw as Record<string, string | undefined>),
  component: InventoryRoute,
});
